<template>
  <Body class="page-list page-peacemaker" />

  <!-- ********** Visual ********** -->
  <section class="section visual">
    <div class="wrap ani-up ani-step">
      <div class="texts">
        <h1 class="title" v-html="$t('우리는brspanclasspink피스spanspanclassblue메이커span')"></h1>
        <div class="desc">
          <p class="point" v-html="$t('평화를부르는어머니사랑의언어를각자속한공동체에확산해주세요br우리사회곳곳에희망과행복평화를피워가는')"></p>
          <p v-html="$t('우리사회곳곳에희망과행복평화를피워가는br우리모두가피스메이커입니다')"></p>
          <p class="guide" v-html="$t('평화선언문카드포스터는다운로드a메뉴에서받으실수있습니다')"></p>
        </div>
        <a class="btn-write main" @click="goToWritePage()">{{ $t('활동등록하기') }}</a>
      </div>
      <div class="visual-img">
        <picture>
          <source media="(max-width:450px)" srcset="/images/peacemaker/visual_peacemaker.png">
          <img src="/images/peacemaker/visual_peacemaker.png" srcset="/images/peacemaker/visual_peacemaker.png, /images/peacemaker/visual_peacemaker@2x.png 2x" alt="">
        </picture>
      </div>
    </div>
  </section>


  <!-- ********** Live ********** -->
  <section v-if="hasEnoughServerItems" class="section live">
    <div class="wrap ani-up ani-step">
      <h2 class="title">{{ $t('실시간참여현황') }}</h2>
      <ul ref="liveListRef" class="live-list">
        <li
          v-for="item in visibleItems"
          :key="item.docId"
          :data-doc-id="item.docId"
        >
          <div class="thumb-wrap">
            <span
              v-if="item.profileImageUrl"
              class="profile-photo"
              :style="{ backgroundImage: `url(${item.profileImageUrl})` }"
            />
            <span
              v-if="item.countryCd"
              class="flag"
              :style="{ backgroundImage: `url(https://pic.watv.org/imgFlag/flag-${item.countryCd.toLowerCase()}.gif)` }"
            />
          </div>
          <div class="text-wrap">
            <div class="title">{{ getLiveItemTitle(item) }}</div>
            <div class="time">{{ getLiveItemTime(item) }}</div>
          </div>
        </li>
      </ul>
    </div>
  </section>


  <!-- ********** Status ********** -->
  <section class="section status">
    <div class="wrap ani-up ani-step">
      <div class="title-wrap">
        <h2 class="title">{{$t('참여현황')}}</h2>
        <p class="desc" v-html="$t('가정과학교직장곳곳에서br피스메이커들의따뜻한실천이이어지고있습니다')"></p>
      </div>
      <div class="count-wrap">
        <div class="text">
          <div class="title">{{ $t('활동횟수') }}</div>
          <div class="count">{{ formatNumber(totalCount.totalParticipationCount ?? 0, locale) }}</div>
        </div>
        <div class="text">
          <div class="title">{{$t('참여인원')}}</div>
          <div class="count">{{ formatNumber(totalCount.totalMemberCount ?? 0, locale) }}</div>
        </div>
      </div>
    </div>
  </section>


  <!-- ********** Card ********** -->
  <section class="section cards">
    <div class="wrap ani-up ani-step">
      <!--pledge-->
      <div class="card pledge">
        <div class="text-wrap">
          <div class="title-wrap">
            <h2 class="title">{{ $t('평화선언') }}</h2>
            <p class="desc" v-html="$t('평화선언으로가족친구동료와평화를약속하고br따뜻한일상을함께만들어가요')"></p>
          </div>
          <div class="count-wrap">
            <div class="text">
              <div class="title">{{ $t('활동횟수') }}</div>
              <div class="count">{{ formatNumber(pledgeCount?.participationCount ?? 0, locale) }}</div>
            </div>
            <div class="text"><!--사용자가 입력하는 동참인원-->
              <div class="title">{{$t('참여인원')}}</div>
              <div class="count">{{ formatNumber(pledgeCount?.memberCount ?? 0, locale) }}</div>
            </div>
          </div>
          <a class="btn-write" @click="goToWritePage(PEACEMAKER_TYPE.PEACE)">{{ $t('활동등록하기') }}</a>
        </div>
        <div class="card-img"></div>
      </div>
      <!--share-->
      <div class="card share">
        <div class="text-wrap">
          <div class="title-wrap">
            <h2 class="title">{{ $t('카드포스터공유') }}</h2>
            <p class="desc" v-html="$t('주위에카드를공유하고가정학교직장등에포스터를br공유해어머니사랑의언어를널리전해보세요')"></p>
          </div>
          <div class="count-wrap">
            <div class="text">
              <div class="title">{{ $t('활동횟수') }}</div>
              <div class="count">{{ formatNumber(shareCount?.participationCount ?? 0, locale) }}</div>
            </div>
            <div class="text"><!--사용자가 입력하는 동참인원-->
              <div class="title">{{$t('참여인원')}}</div>
              <div class="count">{{ formatNumber(shareCount?.memberCount ?? 0, locale) }}</div>
            </div>
          </div>
          <a class="btn-write" @click="goToWritePage(PEACEMAKER_TYPE.SHARE)">{{ $t('활동등록하기') }}</a>
        </div>
        <div class="card-img"></div>
      </div>
      <!--volunteer-->
      <div class="card volunteer">
        <div class="text-wrap">
          <div class="title-wrap">
            <h2 class="title">{{ $t('봉사활동') }}</h2>
            <p class="desc" v-html="$t('2026년은un세계자원봉사자의해2026입니다br어머니의마음으로이웃과지역사회를위한br봉사활동')"></p>
          </div>
          <!--봉사 횟수와 인원은 사용자 글 작성하는 것과 상관없이
          홍보과에서 주기적으로 보내오는 데이터를 보여주세요-->
          <div class="count-wrap">
            <div class="text">
              <div class="title">{{ $t('활동횟수') }}</div>
              <div class="count">{{ formatNumber(volunteerCount?.participationCount ?? 0, locale) }}</div>
            </div>
            <div class="text">
              <div class="title">{{ $t('참여인원') }}</div>
              <div class="count">{{ formatNumber(volunteerCount?.memberCount ?? 0, locale) }}</div>
            </div>
          </div>
          <a class="btn-write" @click="goToWritePage(PEACEMAKER_TYPE.VOLUNTEER)">{{ $t('활동등록하기') }}</a>
        </div>
        <div class="card-img"></div>
      </div>
    </div>
  </section>


</template>

<script lang="ts" setup>
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { PEACEMAKER_TYPE, type PEACEMAKERTypeCode } from '~/constants/peacemaker'
import type { PeacemakerLiveItem } from '~/composables/usePeacemakerLiveFeed'

const { $t } = useNuxtApp()
const { locale } = useI18n()
const { isLoggedIn, showLoginPopup } = useAuth()
const localePath = useLocalePath()

function goToWritePage(activityType?: PEACEMAKERTypeCode) {
  if (!isLoggedIn.value) {
    showLoginPopup()
    return
  }

  const query = activityType != null ? `?activity=${activityType}` : ''
  navigateTo(localePath(`/peacemaker/write${query}`))
}

useHead({
  title: `${$t('우리는피스메이커')} - ${$t('어머니사랑과평화의날캠페인')}`,
  link: [{ rel: 'stylesheet', href: `/css/peacemaker.css?${useBuildTime()}` }],
})

const PLACE_TYPE_TITLE_KEYS: Record<PEACEMAKERTypeCode, string> = {
  [PEACEMAKER_TYPE.PEACE]: 'country에서name님이평화선언을했어요',
  [PEACEMAKER_TYPE.SHARE]: 'country에서name님이포스터를공유했어요',
  [PEACEMAKER_TYPE.VOLUNTEER]: 'country에서name님이봉사활동을했어요',
}

const liveListRef = ref<HTMLElement | null>(null) // 실시간 참여현황 리스트
const { visibleItems, hasEnoughServerItems, startLiveFeed, stopLiveFeed } = usePeacemakerLiveFeed({ liveListRef }) // 실시간 참여현황 데이터 조회

// 실시간 참여현황 제목 포맷
function getLiveItemTitle(item: PeacemakerLiveItem) {
  const key = PLACE_TYPE_TITLE_KEYS[item.placeType] ?? PLACE_TYPE_TITLE_KEYS[PEACEMAKER_TYPE.PEACE]
  return $t(key).replace('{country}', item.countryNm).replace('{name}', item.writerNm)
}

// 실시간 참여현황 시간 포맷
function getLiveItemTime(item: PeacemakerLiveItem) {
  const date = new Date(new Date(item.createdAt).getTime() - 9 * 60 * 60 * 1000)
  return formatRelativeTime(date, locale.value)
}

const { fetchPeacemakerCount } = usePeacemaker();
const { data: peacemakerCount } = await fetchPeacemakerCount();

const totalCount = computed(() => {
  const totalParticipationCount = peacemakerCount.value?.reduce((acc, curr) => acc + (curr.participationCount ?? 0), 0)
  const totalMemberCount = peacemakerCount.value?.reduce((acc, curr) => acc + (curr.memberCount ?? 0), 0)
  return {
    totalParticipationCount,
    totalMemberCount,
  }
});

const pledgeCount = computed(() => {
  return peacemakerCount.value?.find((item) => item.categoryId === PEACEMAKER_TYPE.PEACE);
});
const shareCount = computed(() => {
  return peacemakerCount.value?.find((item) => item.categoryId === PEACEMAKER_TYPE.SHARE);
});
const volunteerCount = computed(() => {
  return peacemakerCount.value?.find((item) => item.categoryId === PEACEMAKER_TYPE.VOLUNTEER);
});

gsap.registerPlugin(ScrollTrigger)

onMounted(async () => {
  const step = gsap.utils.toArray('.ani-step > *') as HTMLElement[]
  step.forEach((box) => {
    const anim = gsap.fromTo(box, { autoAlpha: 0, y: 50 }, { duration: 0.5, autoAlpha: 1, y: 0 })
    ScrollTrigger.create({
      trigger: box,
      start: 'top 85%',
      animation: anim,
      toggleActions: 'play none complete none',
    })
  })

  startLiveFeed()
})

onUnmounted(() => {
  stopLiveFeed()
})
</script>
